export const trialStatusInit = {
    status: 'UNKNOWN',
    colorScheme: 'inherit',
    tooltipText: 'Customer Status: LIVE',
};

export const ACTIONS = {
    SET_STATUS_PENDING: 'SET_STATUS_PENDING',
    SET_STATUS_LIVE: 'SET_STATUS_LIVE',
    SET_STATUS_TRIAL: 'SET_STATUS_TRIAL',
    SET_STATUS_HOLD: 'SET_STATUS_HOLD',
    SET_STATUS_DISABLED: 'SET_STATUS_DISABLED',
};

export const ZENDESK_HELP_CENTER_URL = 'https://help.tcap.cloud/hc/en-gb';

export const zenDeskLink = `https://pingconoc.zendesk.com/access/login?role=agent&return_to=${encodeURIComponent(
    ZENDESK_HELP_CENTER_URL,
)}`;
// JWT SSO endpoint — form POST target for all scopes.
export const ZENDESK_JWT_ENDPOINT = 'https://pingconoc.zendesk.com/access/jwt';

/**
 * Pure decision table: maps managed-company state to a help-icon colour/status action.
 * Colour is always based on the currently managed company, never the user's scope.
 *
 * | partnerID | isActive | approved | isTrial | trialHold | result              |
 * |-----------|----------|----------|---------|-----------|---------------------|
 * | null      | any      | any      | any     | any       | SET_STATUS_LIVE     |
 * | any       | false    | any      | any     | any       | SET_STATUS_DISABLED |
 * | any       | true     | false    | any     | any       | SET_STATUS_PENDING  |
 * | any       | true     | true     | true    | true      | SET_STATUS_HOLD     |
 * | any       | true     | true     | true    | false     | SET_STATUS_TRIAL    |
 * | any       | true     | true     | false   | any       | SET_STATUS_LIVE     |
 *
 * @param {{ isActive: boolean, approved: boolean, isTrial: boolean, trialHold: boolean, partnerID: string|null }} params
 * @returns {string} One of the ACTIONS constants
 */
export function resolveHelpIconStatus({
    isActive,
    approved,
    isTrial,
    trialHold,
    partnerID,
}) {
    if (partnerID == null) return ACTIONS.SET_STATUS_LIVE;
    if (!isActive) return ACTIONS.SET_STATUS_DISABLED;
    if (!approved) return ACTIONS.SET_STATUS_PENDING;
    if (isTrial && trialHold) return ACTIONS.SET_STATUS_HOLD;
    if (isTrial) return ACTIONS.SET_STATUS_TRIAL;
    return ACTIONS.SET_STATUS_LIVE;
}
